import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from 'moment'

@Component({
  selector: 'app-bookslost-report',
  templateUrl: './bookslost-report.component.html',
  styleUrls: ['./bookslost-report.component.css']
})
export class BookslostReportComponent implements OnInit {
  Submitted:boolean=false;
  BookslostReportList=[];
  FilePath:any;

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    BookslostReportModel = {
      FromDate: '',
      ToDate: '',
      IsStaff: 0,
      IsStudent: 0,
      Print:'',
      PersonTypeID:0,
      
  };

  SearchBookslostReport  () {

     this.spinnerService.show();
     this.BookslostReportModel.FromDate =this.BookslostReportModel.FromDate!=null && this.BookslostReportModel.FromDate!=''?moment(this.BookslostReportModel.FromDate).format('DD-MMM-YYYY'):'';
     this.BookslostReportModel.ToDate =this.BookslostReportModel.ToDate!=null && this.BookslostReportModel.ToDate!=''?moment(this.BookslostReportModel.ToDate).format('DD-MMM-YYYY'):'';
    
      this.libraryservice.SearchBookslostReport(JSON.stringify(this.BookslostReportModel)).subscribe( (response:any)=> {
          this.BookslostReportList = response.BookslostReportList;
         this.spinnerService.hide();
         this.globalHelper.CheckActionStatus(response);
      });
  };


   XLSDownload  () {
   
      this.BookslostReportModel.Print = 'XLS';
      this.libraryservice.SearchBookslostReport(JSON.stringify(this.BookslostReportModel)).subscribe( (data:any)=> {
          this.FilePath = data.FilePath;
          window.location = data.FilePath;



      });
  };

  

  ngOnInit() {
    this.SearchBookslostReport();
  }

}
